import React from 'react';

const LayoutCard = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="23"
			height="17"
			viewBox="0 0 23 17"
		>
			<rect
				id="Rectangle_1170"
				data-name="Rectangle 1170"
				width="11"
				height="5"
				transform="translate(0 6)"
				fill="#63666a"
			/>
			<rect
				id="Rectangle_1185"
				data-name="Rectangle 1185"
				width="11"
				height="5"
				transform="translate(0 12)"
				fill="#63666a"
			/>
			<rect
				id="Rectangle_1183"
				data-name="Rectangle 1183"
				width="11"
				height="5"
				fill="#63666a"
			/>
			<rect
				id="Rectangle_1171"
				data-name="Rectangle 1171"
				width="11"
				height="5"
				transform="translate(12 6)"
				fill="#63666a"
			/>
			<rect
				id="Rectangle_1184"
				data-name="Rectangle 1184"
				width="11"
				height="5"
				transform="translate(12 12)"
				fill="#63666a"
			/>
			<rect
				id="Rectangle_1182"
				data-name="Rectangle 1182"
				width="11"
				height="5"
				transform="translate(12)"
				fill="#63666a"
			/>
		</svg>
	);
};

export default LayoutCard;
